import { useEffect, useState } from 'react';
import {
  AgxBodyText,
  AgxButton,
  AgxCaption,
  AgxControlledCheckbox,
  AgxRow,
} from '@urbanx/agx-ui-components';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { formatCurrencyAsNumber } from 'utils/formatNumber';
import useGetPropertyDomainPrice from 'features/domain/useGetPropertyDomainPrice';

interface DomainItemProps {
  id: string;
  productName: string;
  selected: boolean;
  onSelectProductChange: (value: {
    id: string;
    productName: string;
    pricePerUnit?: number;
    value: boolean;
  }) => void;
}

const DomainItem = ({ id, productName, selected, onSelectProductChange }: DomainItemProps) => {
  const dispatch = useAppDispatch();

  const [productSelected, setProductSelected] = useState(selected);

  const {
    domainListingFee,
    domainListingRetrievalSuccessful,
    isDomainListingFeePending,
    reloadDomainPricing,
  } = useGetPropertyDomainPrice();

  useEffect(() => {
    setProductSelected(selected === true);
  }, [selected]);

  useEffect(() => {
    onSelectProductChange({
      id,
      productName,
      pricePerUnit: domainListingFee,
      value: productSelected,
    });
  }, [productSelected]);

  let domainItemBody;

  if (!isDomainListingFeePending && !domainListingRetrievalSuccessful) {
    domainItemBody = (
      <AgxCaption>
        <AgxButton
          small
          naked
          onClick={reloadDomainPricing}
          text={`Failed to retrieve ${productName} pricing. Click here to try again.`}
        ></AgxButton>
      </AgxCaption>
    );
  } else if (isDomainListingFeePending) {
    domainItemBody = <AgxBodyText small>Loading {productName} pricing</AgxBodyText>;
  } else {
    domainItemBody = (
      <AgxBodyText small>
        {domainListingFee != null
          ? `$${formatCurrencyAsNumber(domainListingFee?.toString(), 2)}`
          : 'Complimentary'}
      </AgxBodyText>
    );
  }

  return (
    <AgxRow fill spaceBetween centered mediumGap extraClasses="marketingPackageItem">
      <AgxControlledCheckbox
        naked
        label={productName}
        checked={productSelected}
        disabled={!isDomainListingFeePending && !domainListingRetrievalSuccessful}
        onValueChanged={(value) => setProductSelected(value === true)}
        id={id}
      />
      {domainItemBody}
    </AgxRow>
  );
};

export default DomainItem;
